import React, { useState, useEffect, useContext } from "react";
import { FormGroup, Label } from "reactstrap";
import { FocusedNodeContext } from "../../Service/Context/FocusedNode";

export default ({
  name,
  finishCallback,
  value,
  onChange,
  disabled,
  placeholder,
  style,
  onFocus,
  index,
  patchField,
  onBlur,
  big,
  inlinePlaceholder,
}) => {
  const [ref] = useState(React.createRef());
  const [fieldValue, setFieldValue] = useState(value);
  const [internValue, setInternValue] = useState(value);
  const { setFocusedNode, setListPosition } = useContext(FocusedNodeContext);

  useEffect(() => {
    if (typeof value === "string") {
      if (value !== internValue) {
        if (value !== null) {
          setFieldValue(value);
          setInternValue(value);
        }
      }
    } else if (typeof value === "object") {
      console.error("value in DivInputField was" + value);
    } else {
      console.error("typeof value in DivInputField was", typeof value);
    }
  });

  if (value == null) {
    value = "";
  }

  let opts = {};
  if (disabled === "disabled") {
    opts["disabled"] = true;
  }

  let styles = {
    inputContainer: {
      ...style,
    },
    inputField: {
      minHeight: big ? 250 : 34,
      height: big ? "100%" : "unset",
    },
  };

  function focusNode(e) {
    setFocusedNode(e.target);
    setListPosition(index);

    if (typeof onFocus === "function") {
      onFocus(e);
    }
  }

  return (
    <FormGroup style={styles.inputContainer}>
      <div
        contentEditable={true}
        style={styles.inputField}
        className="form-control"
        {...opts}
        ref={ref}
        onFocus={focusNode}
        onInput={(e) => {
          setInternValue(e.target.innerHTML);
          onChange(e.target.innerHTML, name);
        }}
        onBlur={(e) => {
          finishCallback({ [patchField]: e.currentTarget.innerHTML });
        }}
        name={name}
        dangerouslySetInnerHTML={{ __html: fieldValue }}
        placeholder={inlinePlaceholder ? inlinePlaceholder : undefined}
      ></div>
      {placeholder !== undefined && (
        <Label className={"textarea"} for={name} sm={12}>
          {placeholder}
        </Label>
      )}
    </FormGroup>
  );
};
